<template>
  <div class="board">
    <p class="text-h6">掲示板</p>
    <span>健康チャレンジへの意気込みなど、マナーを守って交流しましょう！</span>
    <v-alert
      border="left"
      colored-border
      type="warning"
      elevation="2"
      style="font-size: 90%"
      class="my-4"
    >
      ご投稿いただく内容は、以下の要件を満たしたものに限ります。投稿内容がふさわしくないと判断した場合は、削除されることがありますのでご了承ください。ご投稿されたことをもって、本投稿条件に同意されたものとみなします。
      <ul>
        <li>公序良俗に反しないもの</li>
        <li>誹謗中傷又は、他人の名誉もしくは信用を毀損する内容を含まないもの</li>
        <li>第三者のプライバシーを侵害していないもの</li>
        <li>著作権、肖像権等第三者の権利を侵害していないもの</li>
      </ul>
      ※写真の投稿について（ファイルサイズ：5MB以内、登録可能ファイル形式：jpeg・bmp・png・gif）
    </v-alert>
    <div class="mb-2 mt-2">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            新規投稿
          </v-btn>
        </template>
        <v-form @submit.prevent ref="post_comment_form">
          <v-card>
            <v-card-title>
              <span class="headline">新規投稿</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="post.nickname"
                      outlined
                      dense
                      label="ニックネーム"
                      :rules="[rules.required, rules.max50]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="post.comment"
                      outlined
                      dense
                      name="comment"
                      label="コメント"
                      :rules="[rules.required, rules.max255]"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-model="post.file"
                      outlined
                      dense
                      label="画像"
                      :hint="file_hint"
                      :persistent-hint="true"
                      prepend-icon="mdi-camera"
                      :show-size="true"
                      :accept="allow_exts"
                      :rules="[rules.file]"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :loading="post_loading"
                :disabled="post_loading"
                @click="postComment"
              >
                投稿
              </v-btn>
              <v-btn
                @click="dialog = false"
              >
                キャンセル
              </v-btn>
            </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
    <!-- 投稿データ取得時のローディング -->
    <div class="text-center">
      <v-progress-circular v-if="isLoading" indeterminate color="secondary" />
    </div>
    <!-- 投稿データが無い場合のメッセージ -->
    <v-alert
      v-if="!isLoading && boards.length == 0"
      border="left"
      colored-border
      type="info"
      elevation="2"
      style="font-size: 90%"
    >
      投稿がまだありません。
    </v-alert>
    <!-- 掲示板リスト -->
    <div>
      <v-pagination
        v-model="page"
        :length="page_length"
        :total-visible="11"
        @input = "pageChange"
        class="mb-4"
      ></v-pagination>
    </div>
    <!-- PC用 -->
    <v-simple-table
      v-if="boards.length > 0 && !is_mobile"
      class="board-table"
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" width="10%">ニックネーム</th>
            <th class="text-left" width="60%">コメント</th>
            <th class="text-left" width="10%">投稿日時</th>
            <th class="text-left" width="15%">画像</th>
            <th class="text-left" width="5%">アクション</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in display_boards" :key="item.id">
            <td style="word-wrap: break-word; word-break: break-word;">{{ item.nickname }}</td>
            <td style="word-wrap: break-word; word-break: break-word;"><p style="white-space:pre-wrap;" v-text="item.comment"></p></td>
            <td>{{ item.created_at | formatDate }}</td>
            <td>
              <a
                :href="item.file_url"
                target="_blank"
                v-if="item.file_url"
              >
                <img
                  :src="item.file_url"
                  width="100px"
                >
              </a>
            </td>
            <td>
              <v-btn
                color="grey"
                small
                icon
                :loading="delete_loading"
                :disabled="delete_loading"
                @click="deleteComment(item)"
                v-if="user.username == item.username"
                class="ml-1"
              >
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- スマホ用 -->
    <v-data-iterator
      :items="display_boards"
      item-key="id"
      :items-per-page="pageSize"
      v-if="boards.length > 0 && is_mobile"
      hide-default-footer
    >
      <template v-slot:default="{ items }">
        <v-row>
          <v-col
            v-for="item in items"
            :key="item.id"
            cols="12"
          >
            <v-card>
              <a
                :href="item.file_url"
                target="_blank"
                v-if="item.file_url"
              >
                <v-img
                  v-bind:src="item.file_url"
                  contain
                  height="200"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </a>
              <v-card-title>
                <v-avatar
                  :color="randomColor(item.id, item.created_at)"
                  class="mr-5">
                  <span class="white--text">{{item.nickname | truncate }}</span>
                </v-avatar>
                {{ item.nickname }}
              </v-card-title>
              <v-card-text>
                <p style="white-space:pre-wrap;" v-text="item.comment"></p>
                <p class="text-end">{{ item.created_at | formatDate }}
                  <v-btn
                    color="grey"
                    small
                    icon
                    :loading="delete_loading"
                    :disabled="delete_loading"
                    @click="deleteComment(item)"
                    v-if="user.username == item.username"
                    class="ml-1"
                  >
                    <v-icon>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
    <v-pagination
      v-model="page"
      :length="page_length"
      :total-visible="11"
      @input = "pageChange"
      class="mt-4"
    ></v-pagination>
    <Dialog ref="confirm"/>
  </div>
</template>

<script>
import { Auth, Storage } from 'aws-amplify'
import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'
import { v4 as uuidv4 } from 'uuid'
const Dialog = () => import('../util/Dialog.vue')

// 投稿取得クエリ（next_token無し）
const listBoardQuery = (limit) => `
  query listBoardQuery {
    listBoard(limit: ${limit}) {
      boards {
        id
        username
        nickname
        comment
        file_path
        created_at
      }
      next_token
    }
  }
`
// 投稿取得クエリ（next_tokenあり）
const listBoardQueryWithToken = (limit, token) => `
  query listBoardQuery {
    listBoard(limit: ${limit}, next_token: "${token}") {
      boards {
        id
        username
        nickname
        comment
        file_path
        created_at
      }
      next_token
    }
  }
`
const getListBoard = async (limit, token) => {
  const { data: { listBoard: data } } = token ? await GraphqlAPI(listBoardQueryWithToken(limit, token)) : await GraphqlAPI(listBoardQuery(limit))
  return {
    boards: data.boards.map((item) => {
      return {
        id: item.id,
        username: item.username,
        nickname: item.nickname,
        comment: item.comment,
        file_path: item.file_path,
        created_at: item.created_at
      }
    }),
    next_token: data.next_token
  }
}
// 新規投稿クエリ
const postCommentMutation = (post) => `
  mutation postCommentMutation {
    postComment(
      input: {
        nickname: ${JSON.stringify(post.nickname)},
        comment: ${JSON.stringify(post.comment.replaceAll('//', '\\/\\/'))},
        file_path: "${post.file_path == null ? '' : post.file_path}",
        username: "none"
      }
    ) {
      id
    }
  }
`
const putPostComment = async (post) => {
  const { data: { postComment: data } } = await GraphqlAPI(postCommentMutation(post))
  return {
    post: data
  }
}
// 投稿削除クエリ
const deleteCommentMutation = (post) => `
  mutation deleteCommentMutation {
    deleteComment(
      id: "${post.id}"
    ) {
      id
    }
  }
`
const putDeleteComment = async (post) => {
  const { data: { deleteComment: data } } = await GraphqlAPI(deleteCommentMutation(post))
  return {
    post: data
  }
}

export default {
  name: 'board',
  components: {
    Dialog
  },
  data () {
    return {
      user: {
        username: null,
        // amplify S3でprotectedとして格納するため利用
        identityId: ''
      },
      post: {},
      // 取得した全投稿
      boards: [],
      // 現ページに表示している投稿
      display_boards: [],
      page: 1,
      // 全ページ数
      page_length: 0,
      // 1ページあたりの表示投稿数
      pageSize: 12,
      // 次の件数を取得するためのトークン
      next_token: '',
      // 最大取得件数
      max_boardlist_size: 12 * 10,
      dialog: false,
      displayMap: {},
      error: '',
      logger: {},
      colorCache: {},
      rules: {
        required: value => !!(value && value.trim()) || '必ず入力してください',
        max50: value => !value || value.length <= 50 || '50文字以下で入力してください',
        max255: value => !value || value.length <= 255 || '255文字以下で入力してください',
        file: value => !value || value.size < this.allow_file_size || this.allow_file_size / (1024 * 1024) + 'MB以下にしてください'
      },
      // 許可するファイル拡張子とサイズ
      allow_exts: ['image/png', 'image/jpeg', 'image/bmp', 'image/gif'],
      allow_file_size: 5242880,
      // 新規投稿用
      post_loading: false,
      delete_loading: false,
      // リスト取得用
      isLoading: true
    }
  },
  computed: {
    file_hint () {
      return this.allow_file_size / (1024 * 1024) + 'MBまでのファイルをアップロード可能です。写真の「位置情報」等はアップロード時に消去されません。共有を希望されない場合は、事前に情報を削除してアップロードをお願いします。'
    },
    is_mobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  filters: {
    truncate: function (value) {
      return value.substring(0, 2)
    },
    formatDate: function (value) {
      if (value) {
        return dayjs.unix(value).format('YYYY/MM/DD HH:mm:ss')
      }
    }
  },
  async created () {
    await this.fetchlistBoards('')
    await this.fetchUserInfo()
  },
  methods: {
    pageChange: function (pageNumber) {
      this.display_boards = this.boards.slice(this.pageSize * (pageNumber - 1), this.pageSize * (pageNumber))
      if (pageNumber === this.page_length && this.next_token) {
        this.nextTokenBoardList()
      }
    },
    // 名前アイコンの色をランダムで生成する
    randomColor (id, createdAt) {
      const rgb = () => [createdAt % 256, (createdAt * 3) % 256, (createdAt * 5) % 256]
      return this.colorCache[id] || (this.colorCache[id] = `rgb(${rgb()[0]}, ${rgb()[1]}, ${rgb()[2]})`)
    },
    // 新規投稿
    async postComment () {
      this.post_loading = true
      if (this.$refs.post_comment_form.validate()) {
        try {
          if (this.post.file) {
            // ファイルタイプチェック
            if (this.allow_exts.indexOf(this.post.file.type) === -1) {
              alert('許可されていないファイルタイプです。')
              this.post_loading = false
              return
            }
            const key = await this.uploadFile(this.post.file)
            if (key) {
              // 他者がprotectedの画像を参照できるように自身のidentityIdも格納
              this.post.file_path = key + ',' + this.user.identityId
            }
          }
          await putPostComment(this.post)
          this.fetchlistBoards()
          this.post = {}
          this.page = 1
        } catch (e) {
          this.$emit('errorHandling', 'コメントの投稿に失敗しました。' + e.errors[0].message)
          this.$log.debug(e)
          this.post_loading = false
        }
        this.$refs.post_comment_form.reset()
        this.dialog = false
      } else {

      }
      this.post_loading = false
    },
    async fetchUserInfo () {
      const currentCredentials = await Auth.currentCredentials()
      this.user.identityId = currentCredentials.identityId
      const currentUserInfo = await Auth.currentAuthenticatedUser()
      this.user.username = currentUserInfo.username
    },
    async fetchlistBoards (nextToken) {
      this.isLoading = true
      try {
        const getListBoardResult = await getListBoard(this.max_boardlist_size, nextToken)
        for (var i = 0; i < getListBoardResult.boards.length; i++) {
          if (getListBoardResult.boards[i].comment) {
            getListBoardResult.boards[i].comment = getListBoardResult.boards[i].comment.replaceAll('\\/\\/', '//')
          }
          // 画像がある場合は別途amplifyで取得
          if (getListBoardResult.boards[i].file_path) {
            // ファイル名とidentityIdに分解
            const pathIdentityIds = getListBoardResult.boards[i].file_path.split(',')
            const key = pathIdentityIds[0]
            const boardIdentityId = pathIdentityIds[1]
            getListBoardResult.boards[i].file_url = await this.getFilePath(key, boardIdentityId)
          }
        }
        if (nextToken) {
          this.boards = this.boards.concat(getListBoardResult.boards)
        } else {
          this.boards = getListBoardResult.boards
        }
        this.next_token = getListBoardResult.next_token
        this.page_length = Math.ceil(this.boards.length / this.pageSize)
        this.display_boards = this.boards.slice(this.pageSize * (this.page - 1), this.pageSize * (this.page))
        this.isLoading = false
      } catch (e) {
        this.$emit('errorHandling', '掲示板の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        this.isLoading = false
      }
    },
    async getFilePath (key, boardIdentityId) {
      if (!key) {
        return ''
      }
      try {
        const filePath = await Storage.get(key, {
          level: 'protected',
          identityId: boardIdentityId
        })
        return filePath
      } catch (e) {
        this.$emit('errorHandling', '画像ファイルの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        return ''
      }
    },
    // 次の件数を取得する
    async nextTokenBoardList () {
      await this.fetchlistBoards(this.next_token)
    },
    async uploadFile (file) {
      if (!file) {
        return null
      }
      // ファイル名を一意に変換
      const fileExt = file.name.split('.').pop()
      const fileName = `${uuidv4()}.${fileExt}`

      try {
        const path = await Storage.put(fileName, file, {
          contentType: file.type,
          ContentEncoding: 'UTF-8',
          Charset: 'UTF-8',
          AccessControlAllowOrigin: '*',
          level: 'protected',
          metadata: { userid: this.user.username }
        })
        return path.key
      } catch (e) {
        this.$emit('errorHandling', '画像のアップロードに失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        return 'error'
      }
    },
    async deleteComment (deletePost) {
      if (!await this.$refs.confirm.open(null, '削除してよろしいですか？')) {
        return
      }
      try {
        this.delete_loading = true
        await putDeleteComment(deletePost)
        // 画像がある場合は別途amplifyで削除
        if (deletePost.file_path) {
          // ファイル名とidentityIdに分解
          const pathIdentityIds = deletePost.file_path.split(',')
          const key = pathIdentityIds[0]
          const boardIdentityId = pathIdentityIds[1]
          await Storage.remove(key, {
            level: 'protected',
            identityId: boardIdentityId
          })
        }
        this.fetchlistBoards()
        this.delete_loading = false
      } catch (e) {
        this.$emit('errorHandling', '削除に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        this.delete_loading = false
        return 'error'
      }
    }
  }
}
</script>
<style scoped lang="scss">
.board-table {
  table-layout: auto;
  border-collapse: collapse;
  border-spacing: 0px;
  th, td {
    padding: 0px;
    border: 1px solid #ccc;
  }
  th {
    background-color: #FFF8E1;
    color:black !important;
    font-weight: 500;
  }
}
</style>
